import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import { HashRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import mailReducer from './store/reducers/mail';
import fareReducer from './store/reducers/fare';
import bookReducer from './store/reducers/book';


const root = ReactDOM.createRoot(document.getElementById('root'));
const rootReducer = combineReducers({
  mail: mailReducer,
  fare: fareReducer,
  book: bookReducer,
  //locations: locationReducer,
});
const store = createStore(rootReducer, applyMiddleware(thunk));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>

    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
